/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgentJobsRouteImport } from './routes/agent-jobs'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RemindersRouteImport } from './routes/reminders'
import { Route as SearchRouteImport } from './routes/search'
import { Route as TasksRouteImport } from './routes/tasks'
import { Route as DevBidiRouteImport } from './routes/dev/bidi'
import { Route as DevDirectionsRouteImport } from './routes/dev.directions'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as PersonalIndexRouteImport } from './routes/personal/index'
import { Route as PersonalAppointmentsRouteImport } from './routes/personal/appointments'
import { Route as PersonalArchiveRouteImport } from './routes/personal/archive'
import { Route as PersonalDailyRouteImport } from './routes/personal/daily'
import { Route as PersonalEnglishRouteImport } from './routes/personal/english'
import { Route as PersonalIdeasRouteImport } from './routes/personal/ideas'
import { Route as PersonalNewsRouteImport } from './routes/personal/news'
import { Route as PersonalNotebookRouteImport } from './routes/personal/notebook'
import { Route as PersonalPmpRouteImport } from './routes/personal/pmp'
import { Route as PersonalPoemsRouteImport } from './routes/personal/poems'
import { Route as PersonalPublishingRouteImport } from './routes/personal/publishing'
import { Route as PersonalWorkshopRouteImport } from './routes/personal/workshop'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as VenturesSlugRouteImport } from './routes/ventures/$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentJobsRoute = AgentJobsRouteImport.update({
  id: '/agent-jobs',
  path: '/agent-jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersRoute = RemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksRoute = TasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const DevBidiRoute = DevBidiRouteImport.update({
  id: '/dev/bidi',
  path: '/dev/bidi',
  getParentRoute: () => rootRouteImport,
} as any)
const DevDirectionsRoute = DevDirectionsRouteImport.update({
  id: '/dev/directions',
  path: '/dev/directions',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalIndexRoute = PersonalIndexRouteImport.update({
  id: '/personal/',
  path: '/personal/',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalAppointmentsRoute = PersonalAppointmentsRouteImport.update({
  id: '/personal/appointments',
  path: '/personal/appointments',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalArchiveRoute = PersonalArchiveRouteImport.update({
  id: '/personal/archive',
  path: '/personal/archive',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalDailyRoute = PersonalDailyRouteImport.update({
  id: '/personal/daily',
  path: '/personal/daily',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalEnglishRoute = PersonalEnglishRouteImport.update({
  id: '/personal/english',
  path: '/personal/english',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalIdeasRoute = PersonalIdeasRouteImport.update({
  id: '/personal/ideas',
  path: '/personal/ideas',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalNewsRoute = PersonalNewsRouteImport.update({
  id: '/personal/news',
  path: '/personal/news',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalNotebookRoute = PersonalNotebookRouteImport.update({
  id: '/personal/notebook',
  path: '/personal/notebook',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalPmpRoute = PersonalPmpRouteImport.update({
  id: '/personal/pmp',
  path: '/personal/pmp',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalPoemsRoute = PersonalPoemsRouteImport.update({
  id: '/personal/poems',
  path: '/personal/poems',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalPublishingRoute = PersonalPublishingRouteImport.update({
  id: '/personal/publishing',
  path: '/personal/publishing',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalWorkshopRoute = PersonalWorkshopRouteImport.update({
  id: '/personal/workshop',
  path: '/personal/workshop',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const VenturesSlugRoute = VenturesSlugRouteImport.update({
  id: '/ventures/$slug',
  path: '/ventures/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agent-jobs': typeof AgentJobsRoute
  '/login': typeof LoginRoute
  '/reminders': typeof RemindersRoute
  '/search': typeof SearchRoute
  '/tasks': typeof TasksRoute
  '/dev/bidi': typeof DevBidiRoute
  '/dev/directions': typeof DevDirectionsRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/personal/appointments': typeof PersonalAppointmentsRoute
  '/personal/archive': typeof PersonalArchiveRoute
  '/personal/daily': typeof PersonalDailyRoute
  '/personal/english': typeof PersonalEnglishRoute
  '/personal/ideas': typeof PersonalIdeasRoute
  '/personal/news': typeof PersonalNewsRoute
  '/personal/notebook': typeof PersonalNotebookRoute
  '/personal/pmp': typeof PersonalPmpRoute
  '/personal/poems': typeof PersonalPoemsRoute
  '/personal/publishing': typeof PersonalPublishingRoute
  '/personal/workshop': typeof PersonalWorkshopRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/ventures/$slug': typeof VenturesSlugRoute
  '/personal/': typeof PersonalIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agent-jobs': typeof AgentJobsRoute
  '/login': typeof LoginRoute
  '/reminders': typeof RemindersRoute
  '/search': typeof SearchRoute
  '/tasks': typeof TasksRoute
  '/dev/bidi': typeof DevBidiRoute
  '/dev/directions': typeof DevDirectionsRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/personal/appointments': typeof PersonalAppointmentsRoute
  '/personal/archive': typeof PersonalArchiveRoute
  '/personal/daily': typeof PersonalDailyRoute
  '/personal/english': typeof PersonalEnglishRoute
  '/personal/ideas': typeof PersonalIdeasRoute
  '/personal/news': typeof PersonalNewsRoute
  '/personal/notebook': typeof PersonalNotebookRoute
  '/personal/pmp': typeof PersonalPmpRoute
  '/personal/poems': typeof PersonalPoemsRoute
  '/personal/publishing': typeof PersonalPublishingRoute
  '/personal/workshop': typeof PersonalWorkshopRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/ventures/$slug': typeof VenturesSlugRoute
  '/personal': typeof PersonalIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/settings': typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/agent-jobs': typeof AgentJobsRoute
  '/login': typeof LoginRoute
  '/reminders': typeof RemindersRoute
  '/search': typeof SearchRoute
  '/tasks': typeof TasksRoute
  '/dev/bidi': typeof DevBidiRoute
  '/dev/directions': typeof DevDirectionsRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/personal/appointments': typeof PersonalAppointmentsRoute
  '/personal/archive': typeof PersonalArchiveRoute
  '/personal/daily': typeof PersonalDailyRoute
  '/personal/english': typeof PersonalEnglishRoute
  '/personal/ideas': typeof PersonalIdeasRoute
  '/personal/news': typeof PersonalNewsRoute
  '/personal/notebook': typeof PersonalNotebookRoute
  '/personal/pmp': typeof PersonalPmpRoute
  '/personal/poems': typeof PersonalPoemsRoute
  '/personal/publishing': typeof PersonalPublishingRoute
  '/personal/workshop': typeof PersonalWorkshopRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/ventures/$slug': typeof VenturesSlugRoute
  '/personal/': typeof PersonalIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agent-jobs'
    | '/login'
    | '/reminders'
    | '/search'
    | '/tasks'
    | '/dev/bidi'
    | '/dev/directions'
    | '/oauth/consent'
    | '/personal/appointments'
    | '/personal/archive'
    | '/personal/daily'
    | '/personal/english'
    | '/personal/ideas'
    | '/personal/news'
    | '/personal/notebook'
    | '/personal/pmp'
    | '/personal/poems'
    | '/personal/publishing'
    | '/personal/workshop'
    | '/projects/$projectId'
    | '/ventures/$slug'
    | '/personal/'
    | '/projects/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agent-jobs'
    | '/login'
    | '/reminders'
    | '/search'
    | '/tasks'
    | '/dev/bidi'
    | '/dev/directions'
    | '/oauth/consent'
    | '/personal/appointments'
    | '/personal/archive'
    | '/personal/daily'
    | '/personal/english'
    | '/personal/ideas'
    | '/personal/news'
    | '/personal/notebook'
    | '/personal/pmp'
    | '/personal/poems'
    | '/personal/publishing'
    | '/personal/workshop'
    | '/projects/$projectId'
    | '/ventures/$slug'
    | '/personal'
    | '/projects'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/agent-jobs'
    | '/login'
    | '/reminders'
    | '/search'
    | '/tasks'
    | '/dev/bidi'
    | '/dev/directions'
    | '/oauth/consent'
    | '/personal/appointments'
    | '/personal/archive'
    | '/personal/daily'
    | '/personal/english'
    | '/personal/ideas'
    | '/personal/news'
    | '/personal/notebook'
    | '/personal/pmp'
    | '/personal/poems'
    | '/personal/publishing'
    | '/personal/workshop'
    | '/projects/$projectId'
    | '/ventures/$slug'
    | '/personal/'
    | '/projects/'
    | '/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AgentJobsRoute: typeof AgentJobsRoute
  LoginRoute: typeof LoginRoute
  RemindersRoute: typeof RemindersRoute
  SearchRoute: typeof SearchRoute
  TasksRoute: typeof TasksRoute
  DevBidiRoute: typeof DevBidiRoute
  DevDirectionsRoute: typeof DevDirectionsRoute
  OauthConsentRoute: typeof OauthConsentRoute
  PersonalAppointmentsRoute: typeof PersonalAppointmentsRoute
  PersonalArchiveRoute: typeof PersonalArchiveRoute
  PersonalDailyRoute: typeof PersonalDailyRoute
  PersonalEnglishRoute: typeof PersonalEnglishRoute
  PersonalIdeasRoute: typeof PersonalIdeasRoute
  PersonalNewsRoute: typeof PersonalNewsRoute
  PersonalNotebookRoute: typeof PersonalNotebookRoute
  PersonalPmpRoute: typeof PersonalPmpRoute
  PersonalPoemsRoute: typeof PersonalPoemsRoute
  PersonalPublishingRoute: typeof PersonalPublishingRoute
  PersonalWorkshopRoute: typeof PersonalWorkshopRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  VenturesSlugRoute: typeof VenturesSlugRoute
  PersonalIndexRoute: typeof PersonalIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-jobs': {
      id: '/agent-jobs'
      path: '/agent-jobs'
      fullPath: '/agent-jobs'
      preLoaderRoute: typeof AgentJobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders': {
      id: '/reminders'
      path: '/reminders'
      fullPath: '/reminders'
      preLoaderRoute: typeof RemindersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks': {
      id: '/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/bidi': {
      id: '/dev/bidi'
      path: '/dev/bidi'
      fullPath: '/dev/bidi'
      preLoaderRoute: typeof DevBidiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/directions': {
      id: '/dev/directions'
      path: '/dev/directions'
      fullPath: '/dev/directions'
      preLoaderRoute: typeof DevDirectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/': {
      id: '/personal/'
      path: '/personal'
      fullPath: '/personal/'
      preLoaderRoute: typeof PersonalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/appointments': {
      id: '/personal/appointments'
      path: '/personal/appointments'
      fullPath: '/personal/appointments'
      preLoaderRoute: typeof PersonalAppointmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/archive': {
      id: '/personal/archive'
      path: '/personal/archive'
      fullPath: '/personal/archive'
      preLoaderRoute: typeof PersonalArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/daily': {
      id: '/personal/daily'
      path: '/personal/daily'
      fullPath: '/personal/daily'
      preLoaderRoute: typeof PersonalDailyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/english': {
      id: '/personal/english'
      path: '/personal/english'
      fullPath: '/personal/english'
      preLoaderRoute: typeof PersonalEnglishRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/ideas': {
      id: '/personal/ideas'
      path: '/personal/ideas'
      fullPath: '/personal/ideas'
      preLoaderRoute: typeof PersonalIdeasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/news': {
      id: '/personal/news'
      path: '/personal/news'
      fullPath: '/personal/news'
      preLoaderRoute: typeof PersonalNewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/notebook': {
      id: '/personal/notebook'
      path: '/personal/notebook'
      fullPath: '/personal/notebook'
      preLoaderRoute: typeof PersonalNotebookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/pmp': {
      id: '/personal/pmp'
      path: '/personal/pmp'
      fullPath: '/personal/pmp'
      preLoaderRoute: typeof PersonalPmpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/poems': {
      id: '/personal/poems'
      path: '/personal/poems'
      fullPath: '/personal/poems'
      preLoaderRoute: typeof PersonalPoemsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/publishing': {
      id: '/personal/publishing'
      path: '/personal/publishing'
      fullPath: '/personal/publishing'
      preLoaderRoute: typeof PersonalPublishingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal/workshop': {
      id: '/personal/workshop'
      path: '/personal/workshop'
      fullPath: '/personal/workshop'
      preLoaderRoute: typeof PersonalWorkshopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ventures/$slug': {
      id: '/ventures/$slug'
      path: '/ventures/$slug'
      fullPath: '/ventures/$slug'
      preLoaderRoute: typeof VenturesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AgentJobsRoute: AgentJobsRoute,
  LoginRoute: LoginRoute,
  RemindersRoute: RemindersRoute,
  SearchRoute: SearchRoute,
  TasksRoute: TasksRoute,
  DevBidiRoute: DevBidiRoute,
  DevDirectionsRoute: DevDirectionsRoute,
  OauthConsentRoute: OauthConsentRoute,
  PersonalAppointmentsRoute: PersonalAppointmentsRoute,
  PersonalArchiveRoute: PersonalArchiveRoute,
  PersonalDailyRoute: PersonalDailyRoute,
  PersonalEnglishRoute: PersonalEnglishRoute,
  PersonalIdeasRoute: PersonalIdeasRoute,
  PersonalNewsRoute: PersonalNewsRoute,
  PersonalNotebookRoute: PersonalNotebookRoute,
  PersonalPmpRoute: PersonalPmpRoute,
  PersonalPoemsRoute: PersonalPoemsRoute,
  PersonalPublishingRoute: PersonalPublishingRoute,
  PersonalWorkshopRoute: PersonalWorkshopRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  VenturesSlugRoute: VenturesSlugRoute,
  PersonalIndexRoute: PersonalIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
